import { useMemo, useState } from "react";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DiagramPageModal } from "../../DiagramPageModal";
import type { DiagramPageLinkProps } from "./types";

export const DiagramPageLink = ({ diagram, designators, label }: DiagramPageLinkProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const designatorsKey = designators.join("\n");
  const hit = useMemo(() => {
    for (const designator of designators) {
      const page = diagram.pageOf(designator);
      if (typeof page === "number")
        return {
          designator,
          page,
          imageUrl: diagram.pageImageOf(designator),
          documentKey: diagram.diagramKeyOf(designator),
        };
    }
    return null;
    // Keyed by the names, not the array: the card builds a fresh one each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diagram, designatorsKey]);

  if (!hit) return null;

  return (
    <>
      <button
        type="button"
        data-testid="circuit-diagram-page"
        onClick={(event) => {
          event.stopPropagation();
          setIsOpen(true);
        }}
        className="flex min-h-[36px] w-full items-center justify-center gap-1.5 rounded-lg border border-indigo-200 bg-indigo-50 px-2 text-[13.5px] font-medium text-indigo-800 hover:border-indigo-400 hover:bg-indigo-100"
      >
        <FileText size={15} className="flex-none text-indigo-600" />
        {t("smartSurveyor.cablesBeta.circuitOnDiagramPage", { designator: hit.designator, page: hit.page })}
      </button>
      <DiagramPageModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        designator={hit.designator}
        label={label}
        page={hit.page}
        imageUrl={hit.imageUrl}
        documentKey={hit.documentKey}
        onOpenFullView={() => {
          setIsOpen(false);
          diagram.open(hit.designator);
        }}
      />
    </>
  );
};
